import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type TableRowProps = ComponentProps<'tr'>;

const TableRow = ({ className, ...props }: TableRowProps) => {
  return (
    <tr
      data-slot="table-row"
      className={cn(
        'border-b transition-colors hover:bg-gray-100 has-aria-expanded:bg-gray-100 data-[state=selected]:bg-gray-100',
        className,
      )}
      {...props}
    />
  );
};

export default TableRow;
